import { RecipientFieldEnum } from 'owa-addins-core';
import { ComposeViewState } from 'owa-mail-compose-store';
import showBccWell from 'owa-mail-compose-store/lib/actions/showBccWell';
import showCcWell from 'owa-mail-compose-store/lib/actions/showCcWell';
import switchToReadWriteRecipient from 'owa-mail-compose-store/lib/actions/switchToReadWriteRecipient';
import getRecipientsFromWellViewState from 'owa-mail-compose-store/lib/utils/getRecipientsFromWellViewState';
import addReadWriteRecipients from 'owa-readwrite-recipient-well/lib/actions/addReadWriteRecipients';
import clearRecipientWell from 'owa-readwrite-recipient-well/lib/actions/clearRecipientWell';
import showHideFindResult from 'owa-readwrite-recipient-well/lib/actions/showHideFindResult';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export const getRecipients = (viewState: ComposeViewState) => (
    type: RecipientFieldEnum
): EmailAddressWrapper[] => {
    const recipientWell = getRecipientWellByType(viewState, type);
    return getRecipientsFromWellViewState(recipientWell);
};

export const setRecipients = (viewState: ComposeViewState) => (
    type: RecipientFieldEnum,
    newRecipients: EmailAddressWrapper[]
): void => {
    showReadWriteRecipientWell(viewState, type);
    const recipientWell: RecipientWellWithFindControlViewState = getRecipientWellByType(
        viewState,
        type
    );
    clearRecipientWell(recipientWell);
    const recipientsData = newRecipients.map(function(recipient: EmailAddressWrapper) {
        return { isValid: true, newPersona: { EmailAddress: recipient } };
    });
    addReadWriteRecipients(recipientWell, recipientsData);
    showHideFindResult(recipientWell, false);
};

export const addRecipients = (viewState: ComposeViewState) => (
    type: RecipientFieldEnum,
    newRecipients: EmailAddressWrapper[]
): void => {
    showReadWriteRecipientWell(viewState, type);
    const recipientWell: RecipientWellWithFindControlViewState = getRecipientWellByType(
        viewState,
        type
    );
    const recipientsData = newRecipients.map(function(recipient: EmailAddressWrapper) {
        return { isValid: true, newPersona: { EmailAddress: recipient } };
    });
    addReadWriteRecipients(recipientWell, recipientsData);
    showHideFindResult(recipientWell, false);
};

function showReadWriteRecipientWell(viewState: ComposeViewState, type: RecipientFieldEnum) {
    if (viewState.showCompactRecipientWell) {
        switchToReadWriteRecipient(viewState);
    }

    switch (type) {
        case RecipientFieldEnum.To:
            return;
        case RecipientFieldEnum.Cc:
            showCcWell(viewState);
            return;
        case RecipientFieldEnum.Bcc:
            showBccWell(viewState);
            return;
    }
}

const getRecipientWellByType = (
    viewState: ComposeViewState,
    type: RecipientFieldEnum
): RecipientWellWithFindControlViewState => {
    let recipientWell;
    switch (type) {
        case RecipientFieldEnum.To:
            recipientWell = viewState.toRecipientWell;
            break;
        case RecipientFieldEnum.Cc:
            recipientWell = viewState.ccRecipientWell;
            break;
        case RecipientFieldEnum.Bcc:
            recipientWell = viewState.bccRecipientWell;
            break;
    }
    return recipientWell;
};
